import { FC } from "react";

import { IErrorComponent } from "../ErrorComponent";
import { ErrorTemplate } from "../blocks/ErrorTemplate";
import { BackendUnexpectedErrorIcon } from "../../../icons/errors";

export const BackendUnexpectedError: FC<IErrorComponent> = (props) => {
  const message = "Произошла непредвиденная ошибка";
  const additionalMessage = "Пожалуйста,"
    + " попробуйте повторить действие позже или перезагрузите страницу";

  return (
    <ErrorTemplate
      {...props}
      icon={BackendUnexpectedErrorIcon}
      message={message}
      additionalMessage={additionalMessage}
    />
  );
};
